import { Badge } from '@frontend/ui'
import { useReportingState } from '../lib/reporting-state'

interface PositionBadgeProps {
  position: string | null | undefined
}

export function PositionBadge({ position }: PositionBadgeProps) {
  const { config } = useReportingState()
  if (!position) return null

  const canonical = config.resolvePosition(position)
  const color = canonical
    ? (config.positionColors[canonical] ?? '#6b7280')
    : '#6b7280'

  return (
    <Badge
      variant='outline'
      className='border-transparent font-semibold'
      style={{ backgroundColor: `${color}20`, color }}
    >
      {position}
    </Badge>
  )
}
